/**
 * Standalone iframe detection utility.
 *
 * Deliberately has ZERO imports so any module in the dependency graph can
 * import it without risking circular-dependency issues (the heavy
 * iframe-auth.service.js pulls in router + store + auth.module, making it
 * unsafe to import into those same modules).
 */

/**
 * Returns true when the app is running inside an iframe.
 * Falls back to true when cross-origin restrictions prevent access to
 * window.top — that itself proves we're in a cross-origin iframe.
 */
export function isInIframe() {
  try {
    return window.self !== window.top
  } catch {
    return true
  }
}

/**
 * Public line sheet pages need no login, so they never wait for PLG's
 * iframe auth handshake. The Line sheet studio frames them as its preview.
 */
export const PUBLIC_LINE_SHEET_PATH_PREFIXES = ['/wishlist/public/', '/v2/wishlist/public/']

export function rendersWithoutIframeAuth(path = window.location.pathname) {
  return !isInIframe() || PUBLIC_LINE_SHEET_PATH_PREFIXES.some(prefix => path.startsWith(prefix))
}
